import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import CopyToClip from "./CopyToClip";
import "../styles/components/dialog-box.scss";

class DialogBox extends React.Component {
  onClose = () => {
    this.props.onClose();
  };

  render() {
    return (
      <div
        className="dialog-box"
        style={{
          display: this.props.isShown ? "flex" : "none"
        }}
      >
        <button
          type="button"
          className="dialog-box--close"
          onClick={this.onClose}
        >
          <CloseOutlined />
        </button>
        <div className="dialog-box-inner">
          <CopyToClip data={this.props.data} />
        </div>
      </div>
    );
  }
}

export default DialogBox;
